import ReportingEnabled from './ReportingEnabled'

export default ReportingEnabled
